import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const industries = [
  ["home-services", "Home Services"],
  ["healthcare", "Healthcare"],
  ["legal", "Legal"],
  ["automotive", "Automotive"],
  ["professional-services", "Professional Services"],
  ["restaurants", "Restaurants"],
  ["retail", "Retail"],
  ["agriculture", "Agriculture"],
] as const;

export default function IndustryLinksSection() {
  return (
    <section className="py-14 md:py-18 bg-background border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <p className="text-sm font-semibold text-accent mb-2">Industry expertise</p>
            <h2 className="text-3xl font-bold">Marketing shaped around how customers choose</h2>
          </div>
          <Link to="/industries" className="inline-flex items-center gap-2 text-accent font-medium hover:underline">
            Explore all industries <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {industries.map(([slug, label]) => (
            <Link
              key={slug}
              to={`/industries/${slug}`}
              className="group flex items-center justify-between rounded-xl border border-border bg-card p-4 hover:border-accent transition-colors"
            >
              <span className="font-medium group-hover:text-accent">{label}</span>
              <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-accent group-hover:translate-x-1 transition-all" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
